import { ref, onMounted } from 'vue';
import usuariosService from '@/services/admin/bases/usuariosService';

/**
 * Composable para obtener los datos de perfil de un usuario en admin.
 *
 * @param {import('vue').Ref<string|number> | string | number} listaId - ref o valor directo
 * @param {import('vue').Ref<string|number> | string | number} userId - ref o valor directo
 */
export function useUsuarioPerfil(listaId, userId) {
    const user = ref(null);
    const loading = ref(false);
    const error = ref(null);

    /**
     * Resuelve el valor actual de un parámetro que puede ser ref o valor directo.
     */
    function resolveParam(param) {
        return param && typeof param === 'object' && 'value' in param ? param.value : param;
    }

    /**
     * Obtiene los datos del usuario desde la API.
     */
    async function fetchUsuario() {
        const resolvedListaId = resolveParam(listaId);
        const resolvedUserId = resolveParam(userId);

        if (!resolvedListaId || !resolvedUserId) {
            error.value = 'Faltan parámetros lista_id o user_id';
            return;
        }

        loading.value = true;
        error.value = null;

        try {
            const result = await usuariosService.getPerfil({
                lista_id: resolvedListaId,
                user_id: resolvedUserId,
            });
            user.value = result.user ?? null;
        } catch (err) {
            console.error('Error al obtener usuario:', err);
            error.value = err.message || 'Error al cargar el usuario';
        } finally {
            loading.value = false;
        }
    }

    onMounted(() => {
        fetchUsuario();
    });

    return {
        user,
        loading,
        error,
        fetchUsuario,
    };
}
